import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Form from '../../../../../../form';
import EditDataButton from './components/EditDataButton';
import FontSizePicker from './components/FontSizePicker';
import ElementStylesGroup from './components/ElementStylesGroup';
import { getRgbString } from '../../../../../../form/input/ColorButton/Color/utils';
import StylesGroup from './components/StylesGroup';

var ChartProperties = function ChartProperties(_ref) {
  var selectedWidget = _ref.selectedWidget,
      cube = _ref.cube,
      dispatch = _ref.dispatch;

  var handlePropertyChange = function handlePropertyChange(sourcePropertyName, propertyName, value) {
    dispatch({
      type: 'change_widget_property',
      payload: {
        widgetId: selectedWidget.id,
        sourcePropertyName: sourcePropertyName,
        propertyName: propertyName,
        value: value
      }
    });
  };

  var handleCaptionChange = function handleCaptionChange(e) {
    handlePropertyChange('caption', 'title', e.target.value);
  };

  var getPropertyChangeHandler = function getPropertyChangeHandler(source) {
    return function (propertyName, value) {
      return handlePropertyChange(source, propertyName, value);
    };
  };

  var handleClearStyles = function handleClearStyles(sourcePropertyName) {
    dispatch({
      type: 'clear_styles',
      payload: {
        widgetId: selectedWidget.id,
        sourcePropertyName: sourcePropertyName
      }
    });
  };

  return React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, null, "Caption"), React.createElement(Form.Input.Text, {
    defaultValue: selectedWidget.caption.title,
    inputProps: {
      placeholder: 'Add caption...',
      onBlur: handleCaptionChange
    },
    onEnter: handleCaptionChange
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    gutterBottom: true
  }, "Data"), React.createElement(EditDataButton, {
    widget: selectedWidget,
    cube: cube
  }, "Select Data")), React.createElement(Grid, {
    item: true
  }, React.createElement("div", null, React.createElement(Form.Input.Checkbox, {
    checked: selectedWidget.series.every(function (series) {
      return series.showValues === 'True';
    }),
    onChange: function onChange(e, checked) {
      return handlePropertyChange('series', 'showValues', checked ? 'True' : '' // setting to 'False' stil displays the labels in single widget preview
      );
    },
    label: "Labels"
  })), React.createElement("div", null, React.createElement(Form.Input.Checkbox, {
    checked: selectedWidget.legend.visibility !== 'Hidden',
    onChange: function onChange(e, checked) {
      return handlePropertyChange('legend', 'visibility', checked ? 'Visibile' : 'Hidden');
    },
    label: "Legend"
  })), React.createElement("div", null, React.createElement(Form.Input.Checkbox, {
    checked: selectedWidget.caption.visibility !== 'Hidden',
    onChange: function onChange(e, checked) {
      return handlePropertyChange('caption', 'visibility', checked ? 'Visibile' : 'Hidden');
    },
    label: "Caption"
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, "Styles"))), React.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(StylesGroup, {
    label: "Caption",
    onClearStyles: function onClearStyles() {
      return handleClearStyles('caption');
    }
  }, React.createElement(ElementStylesGroup, {
    element: selectedWidget.caption,
    onPropertyChange: getPropertyChangeHandler('caption')
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(StylesGroup, {
    label: "Legend",
    onClearStyles: function onClearStyles() {
      return handleClearStyles('legend');
    }
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, React.createElement(FontSizePicker, {
    onChange: function onChange(value) {
      return handlePropertyChange('legend', 'fontSize', value);
    },
    value: selectedWidget.legend.fontSize
  }), React.createElement(Form.Input.ColorButton, {
    type: "background",
    value: selectedWidget.legend.backgroundColor,
    onChange: function onChange(e) {
      return handlePropertyChange('legend', 'backgroundColor', getRgbString(e.rgb));
    }
  }), React.createElement(Form.Input.ColorButton, {
    value: selectedWidget.legend.color,
    onChange: function onChange(e) {
      return handlePropertyChange('legend', 'color', getRgbString(e.rgb));
    }
  })))), React.createElement(Grid, {
    item: true
  }, React.createElement(StylesGroup, {
    label: "Chart",
    onClearStyles: function onClearStyles() {
      return handleClearStyles('');
    }
  }, React.createElement(ElementStylesGroup, {
    element: selectedWidget,
    onPropertyChange: getPropertyChangeHandler('') //TODO: apply all props to other elemants as well?

  }))))));
};

export default ChartProperties;